import { observable, action, runInAction } from 'mobx';
import { PAGE_SIZE_DEFAULT } from '../constants/appConstant';
import webEDIAPI from '../apis/webEDIAPI'
import alertMessage from '../utils/alertMessage'

export default class WebEDIStore {
  constructor(rootStore) {
      this.rootStore = rootStore;
  }
  @observable isFetching = false;
  @observable pageSize = PAGE_SIZE_DEFAULT;
  @observable pageNo = 1;
  @observable currIndex = 0
  @observable itemCount = 0;

  /*SearchResult start*/
  @observable searchItem = {
    "customerPoNo": "",
    "receivedDateBegin": "",
    "receivedDateEnd": "",
    "senderMail": "",
    "status": null,
    "templateType": null
  }
  @observable webEDIList = []
  @action
  async onSearchAction(params,pageNo,pageSize) {
    this.isFetching = true;
    this.webEDIList = [];
    this.pageNo = pageNo;
    this.pageSize = pageSize;
    this.itemCount = 0
    try {
      const response = await webEDIAPI.searchAction(params,pageNo,pageSize);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.webEDIList = response.data.data?.list || []
          this.itemCount = response.data.data?.total
          this.searchItem = params;
        }
      })
    } catch (err) {
      alertMessage.error(err.message);
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  @action
  onChangeWebEDIListList(value){
    this.webEDIList=value
    this.itemCount= 0
    this.pageNo = 1;
    this.pageSize = PAGE_SIZE_DEFAULT;
  }
  /*SearchResult end*/
  /*resend*/
  @action
  async onResendAction(params){
    this.isFetching = true
    try {
      const response = await webEDIAPI.resendAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Resend Success！')
          this.onSearchAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Resend Failed！' + response.data.messageEn +'')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*checkbox*/
  @observable selectedRowKeys=[]
  @observable selectedRows=[]
  @action
  onChangeSelectedRowKeys(selectedRowKeys,selectedRows){
    this.selectedRowKeys=selectedRowKeys
    this.selectedRows=selectedRows
  }
  /*page*/
  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return;
    }
    runInAction(() => {
      this.pageNo = pageNo;
      this.pageSize = pageSize;
    });
    this.onSearchAction(this.searchItem,this.pageNo,this.pageSize)
  }
}
